export const SAAS_MARKETPLACE_INTERSTITIAL_OPEN_EVENT =
  "cx_saas_marketplace_interstitial_open";

export const openSaasMarketplaceInterstitial = () => {
  window.dispatchEvent(
    new CustomEvent(SAAS_MARKETPLACE_INTERSTITIAL_OPEN_EVENT)
  );
};
